// extracted by mini-css-extract-plugin
export default {"wrapper":"roles_wrapper__DgLWQ","Table":"roles_Table__iWzre","Action-btns":"roles_Action-btns__giPnS"};